var TESNAV = TESNAV || {};

//TES.apiUrls is compiled in footer.hbs

TESNAV.urlData = {
  "myResources": "/my-resources/uploads",
  "balance": "/my-resources/buyer-dashboard",
  "myUploads": "/my-resources/uploads",
  "myDownloads": "/my-resources/downloads",
  "myShop": "/teaching-resources/shop/myshop",
  "addResource": "/teaching-resource/upload",
  "myJobs": "/jobs/myalerts.aspx?navCode=471",
  "jobBuilder": "/jobs/myalertsbuilder.aspx",
  "talentBank": "/jobs/talentbank.aspx",
  "myCourses": "/mycourses/",
  "myForums": "/watched/forums",
  "myFollowers": "/member/[[username]]/followers",
  "myThreads": "/watched/threads",
  "myConversations": "/conversations",
  "account": "/authn/account",
  "profile": "/member/[[username]]",
  "products": "/member/[[username]]/subscriptions",
  "preferenceCentre": "/Handlers/PreferenceCentre.ashx",
  "logout": "/api/authn/sign-out-redirect"
}

TESNAV.extendData = function(data) {
  TESNAV.urlData.myCommunity = data.communityHost;
  TESNAV.urlData.myForums = data.communityHost + TESNAV.urlData.myForums;
  TESNAV.urlData.myThreads = data.communityHost + TESNAV.urlData.myThreads;
  TESNAV.urlData.myConversations = data.communityHost + TESNAV.urlData.myConversations;
  TESNAV.urlData.myFollowers = TESNAV.urlData.myFollowers.replace('[[username]]', data.username);
  TESNAV.urlData.profile = TESNAV.urlData.profile.replace('[[username]]', data.username);
  TESNAV.urlData.products = TESNAV.urlData.products.replace('[[username]]', data.username);
  jQuery.extend(data, TESNAV.urlData);
  return data;
}

TESNAV.requestProfile = function() {

  if ((typeof Cookies !== 'undefined') && !Cookies.get('TESCookieUser')) {
    TESNAV.$container.find('.js-profile').addClass('loaded');
    return;
  }

  // Looks like community.tes.com has it's own profile div thingy.
  if (window.location.hostname.match(/community\.tes\.com/)) {
    return;
  }

  function requestBalance () {
    jQuery.ajax({url: '/api/payments/balance/v2/global/buyer', cache: false, dataType: 'json'})
      .then(function (balanceData) {
        var balance;
        var siteCountry = Cookies.get('siteCountry').toLowerCase();

        if (balanceData && siteCountry && balanceData[siteCountry].buyer.balance) {
          balance = balanceData[siteCountry].currency.symbol + balanceData[siteCountry].buyer.balance.toFixed(2);
          if (balance) {
            TESNAV.$container.find('.js-balance').text(balance);
          }
        }
      });
  }

  //fallback for jobs and other sites where its useless to update footer.xml in .net code for now
  var profileApiUrl = (window.TES && window.TES.apiUrls) ? window.TES.apiUrls.profile : "/api/v1/member";

  // get login status / profile information
  jQuery.ajax({url: profileApiUrl, cache: false, dataType: 'json', xhrFields: { withCredentials: true }})
    .done(function (data) {
      var profile;
      try {
        if (data != null) {
          var
            siteCountry;

          if (window.Cookies) {
            siteCountry = window.Cookies.get('siteCountry').toLowerCase();
          }

          if (!siteCountry) {
            siteCountry = 'gb';
          }

          data = TESNAV.extendData(data);
          // add cache busting to the url as the service isn't doing it anymore.
          data.avatarSmall = data.avatarSmall + '?_=' + new Date().getTime();
          data.avatarLarge = data.avatarLarge + '?_=' + new Date().getTime();
          profile = TES.templates['header-profile-v3-' + siteCountry](data);
          TESNAV.$container.find('.js-profile').html(profile);
          
          //Save it globally and fire event so any app can use this data
          TES.loggedInData = data;
          jQuery('body').trigger('memberDataLoaded');

          jQuery('.js-profile').one('click', requestBalance);
          TESNAV.notifications();
        }
      } catch (e) {
        if(window.console && window.console.log) console.log(e);
      }
    })
    .complete(function () {
      TESNAV.$container.find('.js-profile').addClass('loaded');
    });
};
